// Scroll reveals, word-by-word headlines, parallax, kinetic band, counters and card tilt.
// Everything that moves is skipped when the visitor prefers reduced motion.
window.mpMotion = true;
(() => {
  const root = document.documentElement;
  const motion = root.classList.contains('js-motion');
  const progressBar = document.querySelector('.scroll-progress');

  // Brand logos: a blue spotlight walks along the row until the pointer takes over.
  const brandTiles = [...document.querySelectorAll('.brands-grid li:not(.is-clone)')];
  if (motion && brandTiles.length) {
    let spot = -1, timer = 0;
    const show = () => brandTiles.forEach((li, i) => li.classList.toggle('is-spot', i === spot));
    const run = () => {
      clearInterval(timer);
      timer = setInterval(() => { spot = (spot + 1) % brandTiles.length; show(); }, 1200);
    };
    const grid = brandTiles[0].parentElement;
    grid.addEventListener('pointerenter', () => { clearInterval(timer); spot = -1; show(); });
    grid.addEventListener('pointerleave', run);
    run();
  }

  // Section headlines: every word rises out of its own mask when the heading scrolls in.
  // The pack carousel rewrites its heading, so it keeps plain text.
  const headlines = motion ? [...document.querySelectorAll('main h2:not(#reviews-title)')].filter(h => !h.closest('.pack-orbit')) : [];
  const splitWords = node => [...node.childNodes].forEach(child => {
    if (child.nodeType === Node.TEXT_NODE) {
      const fragment = document.createDocumentFragment();
      child.textContent.split(/(\s+)/).forEach(part => {
        if (!part) return;
        if (/^\s+$/.test(part)) return fragment.append(part);
        const mask = document.createElement('span');
        const word = document.createElement('span');
        mask.className = 'word';
        word.textContent = part;
        mask.append(word);
        fragment.append(mask);
      });
      child.replaceWith(fragment);
    } else if (child.nodeType === Node.ELEMENT_NODE && !child.matches('br,.sr-only')) {
      splitWords(child);
    }
  });
  headlines.forEach(heading => {
    heading.setAttribute('aria-label', heading.textContent.replace(/\s+/g, ' ').trim());
    splitWords(heading);
    heading.querySelectorAll('.word').forEach((word, i) => {
      word.setAttribute('aria-hidden', 'true');
      word.style.setProperty('--w', Math.min(i, 12));
    });
    heading.classList.add('is-split');
  });

  // Reveal groups: children rise in sequence, media wipe open.
  const revealTargets = [...document.querySelectorAll('[data-stagger],[data-reveal]'), ...headlines];
  document.querySelectorAll('[data-stagger]').forEach(group =>
    [...group.children].forEach((child, i) => child.style.setProperty('--i', Math.min(i, 6))));
  document.querySelectorAll('.trust-icon svg *').forEach(shape => shape.setAttribute('pathLength', '1'));

  const counters = [...document.querySelectorAll('main [data-count]')];
  const countUp = el => {
    const target = Number(el.dataset.count);
    const start = performance.now();
    const step = now => {
      const t = Math.min((now - start) / 1400, 1);
      el.textContent = String(Math.round(target * (1 - Math.pow(1 - t, 3))));
      if (t < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };

  if (!motion || !('IntersectionObserver' in window)) {
    revealTargets.forEach(el => el.classList.add('is-in'));
  } else {
    // A fully clipped wipe target never intersects, so its parent is watched instead.
    const watched = new Map();
    revealTargets.forEach(el => {
      const watch = el.dataset.reveal === 'wipe' ? el.parentElement : el;
      if (watch !== el) el.style.setProperty('--i', [...watch.children].filter(c => c.dataset.reveal).indexOf(el));
      watched.set(watch, [...(watched.get(watch) || []), el]);
    });
    const revealObserver = new IntersectionObserver(entries => entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      watched.get(entry.target).forEach(el => el.classList.add('is-in'));
      revealObserver.unobserve(entry.target);
    }), { threshold: 0.15, rootMargin: '0px 0px -6% 0px' });
    watched.forEach((_, el) => revealObserver.observe(el));

    // Content that arrives later (product recommendations, sections re-rendered by the theme editor or the cart)
    // would stay invisible: watch it the same way as soon as it is inserted.
    const late = new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => {
      if (node.nodeType !== 1) return;
      const found = [...(node.matches('[data-stagger],[data-reveal]') ? [node] : []), ...node.querySelectorAll('[data-stagger],[data-reveal]')];
      found.forEach(el => {
        if (el.classList.contains('is-in')) return;
        if (el.matches('[data-stagger]')) [...el.children].forEach((child, i) => child.style.setProperty('--i', Math.min(i, 6)));
        const watch = el.dataset.reveal === 'wipe' ? el.parentElement : el;
        watched.set(watch, [...(watched.get(watch) || []), el]);
        revealObserver.observe(watch);
      });
    })));
    late.observe(document.body, { childList: true, subtree: true });

    const counterObserver = new IntersectionObserver(entries => entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      countUp(entry.target);
      counterObserver.unobserve(entry.target);
    }), { threshold: 0.6 });
    counters.forEach(el => {
      el.textContent = '0';
      counterObserver.observe(el);
    });
  }

  // The review score is shown as it is (no count-up): reviews-live.js swaps in the live score, and both together
  // made the number jump.

  // One rAF-throttled scroll pass drives progress, parallax and the kinetic band.
  const parallax = motion ? [...document.querySelectorAll('[data-parallax]')].map(el => ({ el, speed: Number(el.dataset.parallax) || 0, max: Infinity, visible: false })) : [];
  const kinetic = motion ? [...document.querySelectorAll('[data-kinetic]')].map(el => ({ el, dir: Number(el.dataset.kinetic) || 1, visible: false })) : [];

  const measure = () => parallax.forEach(item => {
    const scale = parseFloat(getComputedStyle(item.el).scale);
    // Framed media without overscan stay put; free-floating decorations may travel.
    item.max = scale > 1 ? item.el.offsetHeight * (scale - 1) / 2 : item.el.matches('img,video') ? 0 : Infinity;
  });

  let queued = false;
  if ('IntersectionObserver' in window && (parallax.length || kinetic.length)) {
    const lookup = new Map([...parallax, ...kinetic].map(item => [item.el, item]));
    const visibility = new IntersectionObserver(entries => {
      entries.forEach(entry => { lookup.get(entry.target).visible = entry.isIntersecting; });
      queue();
    }, { rootMargin: '15% 0px' });
    lookup.forEach((_, el) => visibility.observe(el));
  }

  const update = () => {
    queued = false;
    const vh = innerHeight;
    const scrollable = root.scrollHeight - vh;
    if (progressBar) progressBar.style.transform = `scaleX(${scrollable > 0 ? Math.min(scrollY / scrollable, 1) : 0})`;

    parallax.forEach(item => {
      if (!item.visible) return;
      const rect = item.el.getBoundingClientRect();
      const offset = -(rect.top + rect.height / 2 - vh / 2) * item.speed;
      item.el.style.translate = `0 ${Math.max(-item.max, Math.min(item.max, offset)).toFixed(1)}px`;
    });

    kinetic.forEach(item => {
      if (!item.visible) return;
      const rect = item.el.getBoundingClientRect();
      const progress = (vh - rect.top) / (vh + rect.height);
      item.el.style.transform = `translate3d(${((progress - 0.5) * -480 * item.dir).toFixed(1)}px,0,0)`;
    });
  };
  const queue = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(update);
  };
  addEventListener('scroll', queue, { passive: true });
  addEventListener('resize', () => { measure(); queue(); }, { passive: true });
  addEventListener('load', () => { measure(); queue(); });
  measure();
  update();

  // Pack art cards lean toward the pointer.
  if (motion && matchMedia('(hover: hover) and (pointer: fine)').matches) {
    document.querySelectorAll('.award-card').forEach(card => {
      card.addEventListener('pointermove', event => {
        const rect = card.getBoundingClientRect();
        const x = (event.clientX - rect.left) / rect.width - 0.5;
        const y = (event.clientY - rect.top) / rect.height - 0.5;
        card.classList.add('is-tilting');
        card.style.transform = `perspective(900px) rotateX(${(-y * 8).toFixed(2)}deg) rotateY(${(x * 10).toFixed(2)}deg)`;
      });
      card.addEventListener('pointerleave', () => {
        card.classList.remove('is-tilting');
        card.style.transform = '';
      });
    });
  }
})();
